<script>
  import { HeroGeneric, HeroSecondary, HeroPrimary } from "@ObamaFoundation/of-design-system";
  import { setContext } from "svelte";

  export let data;
  export let component = HeroGeneric;

  setContext("containerized", true);

  const { featuredImage, featuredStory, cta, subtitle } = data;
  const isTextOnly = !featuredImage && !featuredStory && !cta && !subtitle;

  // To avoid regressions we remove the margin on demand for components and cases with extra margins
  const getMargin = () => {
    if (component === HeroSecondary && (isTextOnly || featuredImage)) {
      return "mb-0";
    } else if ((component === HeroGeneric || component === HeroPrimary) && isTextOnly) {
      return "mb-0";
    }
    return "mb-15 md:mb-20 lg:mb-25";
  };
</script>

<!-- TODO: Remove margins from this component.
If this is wrapping a single component the margins should be handled on the component itself -->
<div class="-mt-[var(--nav-height)] {getMargin()}">
  <svelte:component this={component} {...data} class="pt-[var(--nav-height)]" />
</div>
